<template>
  <div>
    <el-input
      size="small"
      :placeholder="placeholder"
      :value="userName"
      :disabled="disabled"
      clearable
      v-if="isShowUerInput"
      @clear="clearName"
      @close="organDialog = false"
    >
      <template slot="append">
        <el-button size="small" :disabled="disabled" @click="organDialog = true" type="primary"
          >选择</el-button
        >
      </template>
    </el-input>
    <slot v-else></slot>
    <el-dialog
      append-to-body
      :close-on-click-modal="false"
      title="选择单位或部门"
      :visible.sync="organDialog"
      width="560px"
      class="mini-dialog"
      v-dialogDrag
      @open="dialogOpened"
    >
      <el-row :style="{ height: 'calc(100% - 32px)' }" :gutter="10">
        <el-col :span="24" class="h-full">
          <div class="h-full flex flex-col">
            <div class="flex mt-10px mb-10px">
              <el-input
                size="small"
                placeholder="搜索部门"
                v-model="treeKeyword"
                class="mr-5 flex-1"
                clearable
                @keyup.enter.native="searchTreeData"
              ></el-input>
              <el-button
                size="small"
                type="primary"
                @click="$refs.departmentTree.filter(treeKeyword)"
                >搜索</el-button
              >
            </div>
            <el-tree
              class="role-tree flex-auto overflow-y-auto"
              v-loading="treeLoading"
              highlight-current
              :data="treeData"
              @node-click="handleDocNodeClick"
              :expand-on-click-node="false"
              :props="defaultTreeProps"
              node-key="id"
              ref="departmentTree"
              :filter-node-method="filterDepartMentNode"
              :default-expanded-keys="defaultExpandIds"
              :default-checked-keys="defaultCheckedIds"
              @node-expand="nodeExpand"
              @node-collapse="nodeCollapse"
            >
              <div slot-scope="{ node }" class="node-item">
                <div class="custom-tree-node">
                  <p :title="node.label" class="text-overflow truncate">
                    {{ node.label }}
                  </p>
                </div>
              </div>
            </el-tree>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
import { OrganizationApi } from '@wiz-api/account'

const organizationApi = new OrganizationApi()
export default {
  name: 'department-select',
  components: {},
  props: {
    placeholder: {
      type: String,
      default: '部门或者单位',
    },
    // 是否显示内置选择输入框
    isShowUerInput: {
      type: Boolean,
      default: true,
    },
    // 是否禁用选择按钮
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: '',
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      userName: '',
      showUpIcon: true,
      showLowIcon: true,
      searchPeople: null,
      defaultData: null,
      parentIdList: [],
      treeKeyword: '',
      showChangeDepartDialog: false,
      addPepleProps: {
        visible: true,
        title: '添加部门成员',
      },
      defaultDepartExpandIds: [], // 部门目录树默认展开
      defaultDepartCheckedIds: [], // 部门目录树默认选中
      addDepartmentType: 'department',
      showDepartDialog: false,
      peopleProps: {
        visible: false,
        title: '人员详情',
        data: '',
        type: 'edit',
      },
      changeDepartName: {
        visible: true,
        data: '',
      },
      flatArr: [], // 目录树数组扁平化
      defaultCheckedIds: [],
      currentNode: {}, // 当前节点
      departName: [], // 当前部门层级
      treeLoading: false,

      treeData: [], // 目录树数据
      defaultTreeProps: {
        children: 'children',
        label: 'displayName',
      },
      defaultExpandIds: [],
      organDialog: false,
    }
  },
  computed: {},
  watch: {
    organDialog(newVal, oldVal) {
      this.getCheckDepart(this.value)
      // 初始化数据
      this.$nextTick(() => {
        this.treeKeyword = ''
        this.$refs.departmentTree.filter(null)
      })
    },
    value: {
      handler(value) {
        if (value) {
          this.getDepartName()
        } else {
          this.userName = ''
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getAllTreeListDetails()
  },
  methods: {
    // 选中部门
    async getCheckDepart(id) {
      this.$nextTick(() => {
        if (this.organDialog && id) {
          this.$refs.departmentTree.setCurrentKey(id)
        }
      })
    },
    // 过滤树节点
    searchTreeData() {
      this.$refs.departmentTree.filter(this.treeKeyword)
    },
    // 过滤节点
    filterDepartMentNode(value, data) {
      if (!value) return true
      return data.displayName.indexOf(value) !== -1
    },
    // 目录树点击
    async handleDocNodeClick(data, da1, da2) {
      this.showUpIcon = !data.first
      this.showLowIcon = !data.isLast
      this.currentNode = data
      this.userName = data.displayName
      this.$emit('change', this.currentNode.id)
      this.organDialog = false
    },
    clearName() {
      this.userName = ''
      this.$emit('change', '')
      this.$refs.departmentTree.setCurrentKey(null)
    },
    // 节点展开
    nodeExpand(data) {},
    // 节点关闭
    nodeCollapse(data) {},

    dialogOpened() {},
    // 获取整个目录树
    async getAllTreeListDetails() {
      this.treeLoading = true
      const [err, res] = await organizationApi.getAllListDetails({
        Filter: '',
        Sorting: '',
      })
      if (!err) {
        this.treeData = res.items
        this.getCheckDepart(this.value)
        if (this.currentNode.id) {
          this.defaultExpandIds = [this.currentNode.id]
          this.defaultCheckedIds = [this.currentNode.id]
        } else {
          this.defaultExpandIds = [res.items[0].id]
          this.defaultCheckedIds = [res.items[0].id]
          this.currentNode = res.items[0]
        }
      }
      this.treeLoading = false
    },
    // 获取部门名称
    async getDepartName() {
      if (!this.value) return
      const [err, res] = await organizationApi.get(this.value)
      if (!err) {
        this.userName = res?.displayName || ''
      }
    },
  },
}
</script>

<style scoped lang="scss">
.role-tree {
  height: calc(100% - 74px);
  ::v-deep .el-tree-node__content {
    height: 35px;
    .node-item {
      width: calc(100% - 24px);
      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}
::v-deep .el-select-dropdown__item {
  background-color: #ffffff !important;
  overflow: hidden;
  flex-wrap: nowrap;
}
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-input__validateIcon {
  display: none;
}
.vertial-border {
  background-color: #0086f7;
}
</style>
